import { styled } from '@abyss/web/tools/styled';
import { Card } from '@abyss/web/ui/Card';

export const ListItem = styled('ul', {
  listStyle: 'disc',
  marginLeft: '28px',
  fontSize: '$md',
  color: '$gray8',
  marginTop: '16px',
  marginBottom: '0px',
  fontWeight: '$normal',
  '@screen < $sm': { fontSize: '16px' },
  '& li > span': { display: 'flex', gap: '8px', marginBottom: '10px' },
  '& li::marker': { fontSize: '14px' },
  '& li b': { fontWeight: 'normal' },
});

export const VirtualVisitLogo = styled('div', {
  marginTop: '20px',
  width: '270px',
  height: '220px',
  borderRadius: '50%',
  overflow: 'hidden',
});

export const costStyle = {
  'abyss-text-root': {
    fontSize: '25.63px',
    fontWeight: 'bold',
    marginTop: '12px',
    fontFamily: 'AbyssUHCSan',
    color: '$primary1',
  },
};

export const virtualVisitDescription = {
  'abyss-text-root': {
    fontSize: '$lg',
    lineHeight: '24px',
    color: '$gray8',
    fontWeight: 400,
    '@screen >= $md': {
      margin: '$md 0',
    },
    '@screen < $md': {
      marginTop: '16px',
    },
    wordWrap: 'word-break',
  },
};

export const virtualVisitDescriptionCard = {
  'abyss-text-root': {
    fontSize: '$sm',
    fontWeight: 'bold',
    color: '$gray8',
  },
};

export const availableProviderHeadingStyle = {
  'abyss-heading-root': {
    '@screen >= $md': {
      marginTop: '18px',
    },
    '@screen < $md': {
      marginTop: '12px',
    },
  },
};

export const StyledVirtualUrgentCareSpan = styled('span', {
  color: '#002677',
  fontSize: '25.63px',
  fontWeight: '700',
  lineHeight: '32px',
  wordWrap: 'break-word',
});

export const StyledYouPay = styled('span', {
  color: '#323333',
  fontSize: '14px',
  fontFamily: 'UHC2020 Sans',
  fontWeight: '700',
  lineHeight: '18px',
  wordWrap: 'break-word',
});

export const StyledClaimsSpan01 = styled('span', {
  color: '#002677',
  fontSize: '20px',
  fontFamily: 'SF Pro',
  fontWeight: '700',
  lineHeight: '24px',
  wordWrap: 'break-word',
});

export const StyledClaimsSpan02 = styled('span', {
  color: '#002677',
  fontSize: '28px',
  fontFamily: 'UHC Serif Headline',
  fontWeight: '600',
  lineHeight: '32px',
  wordWrap: 'break-word',
});

export const StyledClaims = styled('span', {
  color: '#4B4D4F',
  fontSize: '12px',
  fontFamily: 'UHC2020 Sans',
  fontWeight: '500',
  lineHeight: '16px',
  wordWrap: 'break-word',
});

export const StyledFrame204977607 = styled('div', {
  height: '31px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '4px',
  display: 'flex',
});

export const StyledFrame2147227429 = styled('div', {
  height: '37px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
  display: 'inline-flex',
});

// for get cost estimate link

export const StyledLink = styled('div', {
  height: '24px',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '4px',
  display: 'inline-flex',
  textDecoration: 'none',
});

export const StyledLeftIconAndLink = styled('div', {
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '4px',
  display: 'flex',
  cursor: 'pointer',
});

export const StyledTextLabelGetCost = styled('a', {
  color: '#196ECF',
  fontSize: '16px',
  fontFamily: 'UHC2020 Sans',
  fontWeight: '600',
  lineHeight: '20px',
  wordWrap: 'break-word',
});

export const VirtualCareHeader = styled('div', {
  alignSelf: 'stretch',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '48px',
  display: 'inline-flex',
  width: '100%',
  paddingRight: '5%',
});

export const StyledVirtualPrimaryCareSpan = styled('span', {
  color: '#002677',
  fontSize: '25.63px',
  fontWeight: '700',
  lineHeight: '32px',
  wordWrap: 'break-word',
});
export const VirtualSpecialtyCareHeader = styled('div', {
  alignSelf: 'stretch',
  alignItems: 'center',
  gap: '48px',
  display: 'inline-flex',
  width: '100%',
  paddingRight: '5%',
});

export const virtualSpecialtyCareHeaderDescription = {
  'abyss-text-root': {
    fontSize: '$lg',
    lineHeight: '24px',
    color: '$gray8',
    fontWeight: 400,
    '@screen >= $md': {
      marginTop: '16px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '@screen < $md': {
      marginTop: '16px',
      fontSize: '$md',
      lineHeight: '20px',
      whiteSpace: 'normal',
      wordWrap: 'break-word',
    },
  },
};

export const StyledVirtualSpecialtyCard = styled(Card, {
  minWidth: '384px',
  '@screen < $sm': {
    minWidth: '318px',
  },
  display: 'flex',
  height: '100%',
  borderRadius: '12px',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  padding: '16px',
  gap: '16px',
  marginTop: '0px !important',
  overflow: 'hidden',
  border: '0.5px solid #CBCCCD',
  boxShadow: '0 4px 4px -2px rgba(0, 0, 0, 0.16)',
  background: '#fff',
  '& > div:first-child': {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    justifyContent: 'space-between',
  },
});

export const StyledVirtualSpecialtyCardSection = styled('div', {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '16px',
  variants: {
    hasLogo: {
      true: { gap: '2px' },
      false: { gap: '16px' },
    },
  },
});

export const VirtualSectionWrap = styled('div', {
  display: 'flex',
  marginTop: '8px',
  '@screen < $lg': {
    marginTop: '$sm',
  },
  '@screen < $sm': {
    marginTop: '$md',
    paddingLeft: '16px',
    paddingRight: '16px',
  },
});

export const StyledCardWrapper = styled('div', {
  width: '100%',
  '& .abyss-card-root': {
    '@screen < $md': {
      width: '100% !important',
      maxWidth: 'none !important',
    },
  },
});

export const VirtualCareHeaderContainer = styled('div', {
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'center',
  '@screen < $md': {
    width: '60% !important',
  },
});
